import { V2 } from '@firmable/common';
import Image from 'next/image';

export const OrgAvatar = ({ org }: { org: { hasImage: boolean; imageUrl: string; name: string } }) =>
  org.hasImage ? (
    <Image src={org.imageUrl} alt={org.name} width={48} height={48} className="rounded object-cover" />
  ) : (
    <div className="w-12 h-12 rounded bg-brand-1-100 flex items-center justify-center text-brand-1-700 font-semibold text-lg">
      {org.name.charAt(0).toUpperCase()}
    </div>
  );

export const CreateCompanyFooter = ({ onClick }: { onClick: () => void }) => (
  <>
    <p className="text-sm text-neutral-600 text-center">or</p>
    <V2.Button variant="secondary" size="lg" onClick={onClick} className="!w-full !h-11">
      Create new company
    </V2.Button>
  </>
);
